import { ApplierOption } from '../../../lib/helpers/ApplierOption';
import { TFunction } from 'i18next';

export function GetBulkActionTitle(t: TFunction<string, undefined>, type: ApplierOption | string): string {
  const translateText = (text: string, translationKey: string) => {
    const defaultKey = `BULK_ACTION_TITLE_${translationKey}`;
    return t(defaultKey, { defaultValue: text });
  };

  // Need a list of actions based on the selected TODO Like the SummaryGenerator and FilterApplier
  // SmartSendBulkActionOptions
  switch (type) {
    case 'Status:Active':
      return translateText('Restore', 'RESTORE');
    case 'Status:Archived':
      return translateText('Archive', 'ARCHIVE');
    case 'Status:Deleted':
      return translateText('Delete', 'DELETE');
    case 'Status:Inactive':
      return translateText('Save for Later', 'SAVE_FOR_LATER');
    case 'Download:CSV:Booked':
      return translateText('Export Booked', 'EXPORT_BOOKED');
    case 'Download:CSV:Orders':
      return translateText('Export Orders', 'EXPORT_ORDERS');
    case 'Download:CSV:Sold':
      return translateText('Export Items', 'EXPORT_ITEMS');
    case 'Download:PickingList':
      return translateText('Picking List', 'PICKING_LIST');
    case 'Dispatch':
    case 'Dispatch:Confirm':
      return translateText('Notify Marketplace', 'NOTIFY_MARKETPLACE');
    case 'MarkAsPackaged':
      return translateText('Mark as Packaged', 'MARK_AS_PACKAGED');
    case 'MarkAsNotPackaged':
      return translateText('Mark as Unpackaged', 'MARK_AS_UNPACKAGED');
    case 'Tags':
      return translateText('Add Tags', 'ADD_TAGS');
    case 'RecipientContactDetails:Add':
      return translateText('Add Details', 'ADD_DETAILS');
    case 'RecipientContactDetails:Change':
      return translateText('Change Details', 'CHANGE_DETAILS');
    case 'Extras':
      return translateText('Add Extras', 'ADD_EXTRAS');
    case 'Protection':
      return translateText('Add Protection', 'ADD_PROTECTION');
    case 'Service:Add':
      return translateText('Add Service', 'ADD_SERVICE');
    case 'Service:Change':
      return translateText('Change Service', 'CHANGE_SERVICE');
    case 'Dimensions:Add':
      return translateText('Add Dimensions', 'ADD_DIMENSIONS');
    case 'TariffCodes:Add':
      return translateText('Add Tariff Code', 'ADD_TARIFF_CODE');
    case 'Dimensions:Change':
      return translateText('Change Dimensions', 'CHANGE_DIMENSIONS');
    case 'Return':
      return translateText('Arrange Return Label', 'ARRANGE_RETURN_LABEL');
    case 'PreferredCollectionDate':
      return translateText('Collection Date', 'COLLECTION_DATE');
    case 'Download:Labels':
      return translateText('Labels', 'LABELS');
    case 'LIST':
      return translateText('Bulk Actions', 'BULK_ACTIONS');
    default:
      return type || translateText('Bulk Actions', 'BULK_ACTIONS');
  }
}
